export default __webpack_public_path__ + "static/Cakes_Bakes-aded912f129055caf9df83c14ea50b0b.png";